/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as controlBuildingV1 from "./keyapis_telemetry_control_building_v1.pb"
import * as controlDeviceV1 from "./keyapis_telemetry_control_device_v1.pb"

/**
 * Сервис реализует поток изменений ресурсов домена Телеметрии
 */

/**
 * Сервис реализует поток изменений ресурсов домена Телеметрии.
 * Авторизация:
 *   - X-Api-Key: apiKey
 */
export class StreamServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  // method PostResourceFullDuplex(bidirectional streams) not supported yet

}

/**
 * Запрос создания задачи с клиента на сервере
 */
export type PostResourceFullDuplexRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId?: string
}
/**
 * task
 */
& fm.OneOf<{
  /**
   * Результат обработки ресурса на клиенте
   */
  readonly resourceAsyncStatus: PostResourceFullDuplexRequestResourceAsyncStatusDto
}>
/**
 * Результат обработки ресурса на клиенте
 */
export type PostResourceFullDuplexRequestResourceAsyncStatusDto = {
  /**
   * Идентификатор ресурса
   */
  resourceId: ResourceIdRequestDto
}
/**
 * type
 */
& fm.OptionalOneOf<{
  /**
   * Успех
   */
  readonly data: PostResourceFullDuplexRequestResourceAsyncStatusSuccessDto
  /**
   * Ошибка
   */
  readonly error: PostResourceFullDuplexRequestResourceAsyncStatusErrorDto
}>
/**
 * Ошибки обработки ресурса на клиенте
 */
export type PostResourceFullDuplexRequestResourceAsyncStatusErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Неизвестная ошибка
   */
  readonly unknown: PostResourceFullDuplexRequestResourceAsyncStatusErrorUnknownErrorDto
}>
/**
 * Ошибки обработки ресурса на клиенте
 */
export type PostResourceFullDuplexRequestResourceAsyncStatusErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Неизвестная ошибка
   */
  readonly unknown: PostResourceFullDuplexRequestResourceAsyncStatusErrorUnknownErrorResponseDto
}>
/**
 * Неизвестная ошибка на стороне клиента
 */
export type PostResourceFullDuplexRequestResourceAsyncStatusErrorUnknownErrorDto = {
  /**
   * Произвольный текст ошибки на стороне клиента.
   * Отправляется в случае если в спецификации нет подходящей ошибки.
   * После анализа таких ошибок в спецификацию добавляется специальный тип под эту ошибку
   */
  message: string
}
/**
 * Неизвестная ошибка на стороне клиента
 */
export type PostResourceFullDuplexRequestResourceAsyncStatusErrorUnknownErrorResponseDto = {
  /**
   * Произвольный текст ошибки на стороне клиента.
   * Отправляется в случае если в спецификации нет подходящей ошибки.
   * После анализа таких ошибок в спецификацию добавляется специальный тип под эту ошибку
   */
  message: string
}
/**
 * Команда принята
 */
export type PostResourceFullDuplexRequestResourceAsyncStatusSuccessDto = {
}
/**
 * Событие создания/изменения ресурса
 */
export type PostResourceFullDuplexResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
}
/**
 * event
 */
& fm.OneOf<{
  /**
   * Событие создания/обновления ресурса
   */
  readonly upsertResourceEvent: PostResourceFullDuplexResponseUpsertResourceEventDto
  /**
   * Событие удаления ресурса
   */
  readonly removeResourceEvent: PostResourceFullDuplexResponseRemoveResourceEventDto
}>
/**
 * Событие удаления ресурса
 */
export type PostResourceFullDuplexResponseRemoveResourceEventDto = {
  /**
   * Идентификатор ресурса
   */
  resourceId: ResourceIdResponseDto
}
/**
 * Событие создания/обновления ресурса
 */
export type PostResourceFullDuplexResponseUpsertResourceEventDto = {
  /**
   * Ресурс
   */
  resource: ResourceResponseDto
}
/**
 * Ресурс
 */
export type ResourceRequestDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Объект строительства
   */
  readonly building: controlBuildingV1.BuildingRequestDto
  /**
   * Идентификатор ПУ
   */
  readonly device: controlDeviceV1.DeviceRequestDto
  /**
   * Точка учета
   */
  readonly metricPoint: controlDeviceV1.DeviceMetricPointRequestDto
  /**
   * Индикатор
   */
  readonly indicator: controlDeviceV1.IndicatorRequestDto
  /**
   * Связка индикатора и ТУ
   */
  readonly indicatorMetricPoint: controlDeviceV1.DeviceIndicatorMetricPointRequestDto
}>
/**
 * Ресурс
 */
export type ResourceResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Объект строительства
   */
  readonly building: controlBuildingV1.BuildingResponseDto
  /**
   * Идентификатор ПУ
   */
  readonly device: controlDeviceV1.DeviceResponseDto
  /**
   * Точка учета
   */
  readonly metricPoint: controlDeviceV1.DeviceMetricPointResponseDto
  /**
   * Индикатор
   */
  readonly indicator: controlDeviceV1.IndicatorResponseDto
  /**
   * Связка индикатора и ТУ
   */
  readonly indicatorMetricPoint: controlDeviceV1.DeviceIndicatorMetricPointResponseDto
}>
/**
 * Идентификатор ресурса
 */
export type ResourceIdRequestDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Идентификатор объекта строительства
   */
  readonly buildingId: number
  /**
   * Идентификатор ПУ
   */
  readonly deviceId: number
  /**
   * Идентификатор ТУ
   */
  readonly metricPointId: string
  /**
   * Идентификатор индикатора
   */
  readonly indicatorId: number
  /**
   * Связка индикатора и ТУ
   */
  readonly indicatorMetricPoint: controlDeviceV1.DeviceIndicatorMetricPointRequestDto
}>
/**
 * Идентификатор ресурса
 */
export type ResourceIdResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Идентификатор объекта строительства
   */
  readonly buildingId: number
  /**
   * Идентификатор ПУ
   */
  readonly deviceId: number
  /**
   * Идентификатор ТУ
   */
  readonly metricPointId: string
  /**
   * Идентификатор индикатора
   */
  readonly indicatorId: number
  /**
   * Связка индикатора и ТУ
   */
  readonly indicatorMetricPoint: controlDeviceV1.DeviceIndicatorMetricPointResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос создания задачи с клиента на сервере
   */
  "PostResourceFullDuplexRequest": {
    "kind": "class",
    "text": "Запрос создания задачи с клиента на сервере",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
      },
      /**
       * Результат обработки ресурса на клиенте
       */
      "resourceAsyncStatus": {
        "type": "PostResourceFullDuplexRequest.ResourceAsyncStatus",
        "text": "Результат обработки ресурса на клиенте",
      },
    },
  },
  /**
   * Результат обработки ресурса на клиенте
   */
  "PostResourceFullDuplexRequest.ResourceAsyncStatus": {
    "kind": "class",
    "text": "Результат обработки ресурса на клиенте",
    "fields": {
      /**
       * Идентификатор ресурса
       */
      "resourceId": {
        "type": "ResourceId",
        "text": "Идентификатор ресурса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Успех
       */
      "data": {
        "type": "PostResourceFullDuplexRequest.ResourceAsyncStatus.Success",
        "text": "Успех",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostResourceFullDuplexRequest.ResourceAsyncStatus.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибки обработки ресурса на клиенте
   */
  "PostResourceFullDuplexRequest.ResourceAsyncStatus.Error": {
    "kind": "class",
    "text": "Ошибки обработки ресурса на клиенте",
    "fields": {
      /**
       * Неизвестная ошибка
       */
      "unknown": {
        "type": "PostResourceFullDuplexRequest.ResourceAsyncStatus.Error.UnknownError",
        "text": "Неизвестная ошибка",
      },
    },
  },
  /**
   * Неизвестная ошибка на стороне клиента
   */
  "PostResourceFullDuplexRequest.ResourceAsyncStatus.Error.UnknownError": {
    "kind": "class",
    "text": "Неизвестная ошибка на стороне клиента",
    "fields": {
      /**
       * Произвольный текст ошибки на стороне клиента.
       * Отправляется в случае если в спецификации нет подходящей ошибки.
       * После анализа таких ошибок в спецификацию добавляется специальный тип под эту ошибку
       */
      "message": {
        "type": "string",
        "text": "Произвольный текст ошибки на стороне клиента.\nОтправляется в случае если в спецификации нет подходящей ошибки.\nПосле анализа таких ошибок в спецификацию добавляется специальный тип под эту ошибку",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Команда принята
   */
  "PostResourceFullDuplexRequest.ResourceAsyncStatus.Success": {
    "kind": "class",
    "text": "Команда принята",
  },
  /**
   * Событие создания/изменения ресурса
   */
  "PostResourceFullDuplexResponse": {
    "kind": "class",
    "text": "Событие создания/изменения ресурса",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Событие создания/обновления ресурса
       */
      "upsertResourceEvent": {
        "type": "PostResourceFullDuplexResponse.UpsertResourceEvent",
        "text": "Событие создания/обновления ресурса",
      },
      /**
       * Событие удаления ресурса
       */
      "removeResourceEvent": {
        "type": "PostResourceFullDuplexResponse.RemoveResourceEvent",
        "text": "Событие удаления ресурса",
      },
    },
  },
  /**
   * Событие удаления ресурса
   */
  "PostResourceFullDuplexResponse.RemoveResourceEvent": {
    "kind": "class",
    "text": "Событие удаления ресурса",
    "fields": {
      /**
       * Идентификатор ресурса
       */
      "resourceId": {
        "type": "ResourceId",
        "text": "Идентификатор ресурса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Событие создания/обновления ресурса
   */
  "PostResourceFullDuplexResponse.UpsertResourceEvent": {
    "kind": "class",
    "text": "Событие создания/обновления ресурса",
    "fields": {
      /**
       * Ресурс
       */
      "resource": {
        "type": "Resource",
        "text": "Ресурс",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ресурс
   */
  "Resource": {
    "kind": "class",
    "text": "Ресурс",
    "fields": {
      /**
       * Объект строительства
       */
      "building": {
        "type": "Building",
        "text": "Объект строительства",
      },
      /**
       * Идентификатор ПУ
       */
      "device": {
        "type": "Device",
        "text": "Идентификатор ПУ",
      },
      /**
       * Точка учета
       */
      "metricPoint": {
        "type": "Device.MetricPoint",
        "text": "Точка учета",
      },
      /**
       * Индикатор
       */
      "indicator": {
        "type": "Indicator",
        "text": "Индикатор",
      },
      /**
       * Связка индикатора и ТУ
       */
      "indicatorMetricPoint": {
        "type": "DeviceIndicatorMetricPoint",
        "text": "Связка индикатора и ТУ",
      },
    },
  },
  /**
   * Идентификатор ресурса
   */
  "ResourceId": {
    "kind": "class",
    "text": "Идентификатор ресурса",
    "fields": {
      /**
       * Идентификатор объекта строительства
       */
      "buildingId": {
        "type": "int32",
        "text": "Идентификатор объекта строительства",
      },
      /**
       * Идентификатор ПУ
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор ПУ",
      },
      /**
       * Идентификатор ТУ
       */
      "metricPointId": {
        "type": "string",
        "text": "Идентификатор ТУ",
      },
      /**
       * Идентификатор индикатора
       */
      "indicatorId": {
        "type": "int32",
        "text": "Идентификатор индикатора",
      },
      /**
       * Связка индикатора и ТУ
       */
      "indicatorMetricPoint": {
        "type": "DeviceIndicatorMetricPoint",
        "text": "Связка индикатора и ТУ",
      },
    },
  },
}